<template>
<span class="gbpro-rich-text">
  <template v-for="(part, index) in parts">
    <a
      v-if="part.type === 'link'"
      :key="`link-${index}`"
      :href="part.href"
      class="gbpro-inline-link">
{{ part.content }}
</a>
    <template v-else>
{{ part.content }}
</template>
  </template>
</span>
</template>

<script>
// 解析 [文案](链接) 格式，用于正文内链
export function parseRichText(text) {
	if (!text || typeof text !== 'string') {
		return [{ type: 'text', content: text || '' }]
	}

	const parts = []
	const pattern = /\[([^\]]+)\]\(([^)]+)\)/g
	let lastIndex = 0
	let match = pattern.exec(text)

	while (match) {
		if (match.index > lastIndex) {
			parts.push({ type: 'text', content: text.slice(lastIndex, match.index) })
		}
		parts.push({ type: 'link', content: match[1], href: match[2] })
		lastIndex = pattern.lastIndex
		match = pattern.exec(text)
	}

	if (lastIndex < text.length) {
		parts.push({ type: 'text', content: text.slice(lastIndex) })
	}

	return parts.length ? parts : [{ type: 'text', content: text }]
}

export default {
	name: 'GbproRichText',
	props: {
		text: {
			type: String,
			required: true,
		},
	},
	computed: {
		parts() {
			return parseRichText(this.text)
		},
	},
}
</script>
